<template>
	<div ref="popupContainer">
		<vs-popup :active.sync="isPopUpActive" :title="$props.mission.perform + ' - '+$props.thisPeriod+  ($props.mission.price? ' - ' + $props.mission.price+ ' €':'')" >
			<div v-if = "isLoading"><circular-loader/></div>
			<div v-else>
				<!-- <vs-select
						v-model="missionSelected"
						class="w-full select-large"
						placeholder="Add"
						:key = "productRefreshkey"
						autocomplete
						multiple

					>
						<vs-select-item
							:key="index"
							:value="item.perform"
							:text="item.perform"
							v-for="(item, index) in missionList"
							class="w-full"
						/>
					</vs-select> -->
		<vs-table
		v-if ="missionSelected.length>0"
		stripe pagination max-items="25"
		class = "pt-5"
		:data="flexibleMissions"
		:key="refreshKey"
		:max-height= "tableHeight + 'px'"
		id="tb"
		noDataText="Aucune contract corresponde"
    >
	<template slot="thead">
        <vs-th class="th-sticky">Prestation</vs-th>
        <vs-th class="th-sticky pdl0" style="width: 125px;">Budget %</vs-th>
        <vs-th class="th-sticky pdl0" style="width: 125px;">Budget €</vs-th>
        <vs-th class="th-sticky pdl0">Consultant</vs-th>
		<vs-th class="th-sticky pdl0">Thematique</vs-th>
        <vs-th class="th-sticky pdl0">Mots</vs-th>
        <vs-th class="th-sticky pdl0">Langue</vs-th>
    </template>
	<template slot-scope="{data}">
        <vs-tr :key="index" v-for="(item, index) in data">
			<vs-td>
				{{item.mission}}
			</vs-td>
			<!-- <vs-td>
				<vs-input ref="myInput" placeholder="" v-model="item.budgetPer" @change="(event) => handleInputChange(event, 1)" type="number" :class="{ 'bg-grey': isGreyPercentBackground }"/>
			</vs-td> -->
			<vs-td>
			<vx-input-group >
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span class="flex"
                    ><vs-icon icon="percent" size="small"></vs-icon
                  ></span>
				  
                </div>
				
              </template>
			  <vs-input ref="myInput" placeholder="" v-model="item.budgetPer" @change="(event) => handleInputChange(event, 1)" type="number" :class="{ 'bg-grey': isGreyPercentBackground }"/>
            </vx-input-group>
		</vs-td>
			<vs-td>
				<vx-input-group >
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span class="flex"
                    ><vs-icon icon="euro" size="small"></vs-icon
                  ></span>
                </div>
				
              </template>
			 <vs-input ref="myAmountInput" placeholder="" v-model="item.budgetAmount" @change="(event) => handleInputChange(event, 2)" type="number" :class="{ 'bg-grey': isGreyAmountBackground }"/>
            </vx-input-group>
			</vs-td>

			<vs-td>
				<vs-select
						v-model="item.consultant"
						class="w-full select-large"
						placeholder="Consultant"
						autocomplete

					>
						<vs-select-item
							:key="index"
							:value="item1.value"
							:text="item1.name"
							v-for="(item1, index) in allCollabList"
							class="w-full"
						/>
					</vs-select>
			</vs-td>
			<vs-td>
				<vs-input placeholder="Thematique" v-model="item.category" @change="calcSum()" v-if="contentListIds.includes(item.product_id)"/>
			</vs-td>

			<vs-td>

				<vs-input placeholder="Mots" v-model="item.num_words" @change="calcSum()" v-if="contentListIds.includes(item.product_id)"/>
			</vs-td>
			<vs-td v-if="contentListIds.includes(item.product_id)">
					<vs-select
						v-model="item.language"
						class="w-full select-large"
						placeholder="Langue"
						autocomplete>
					<vs-select-item
					  :key="index"
					  :value="item.id"
					  :text="item.name"
					  v-for="(item, index) in contentLang"
					  class="w-full"
				  />
					</vs-select>

			</vs-td>
        </vs-tr>
		<vs-tr >
			<vs-td style="font-weight: bold;">
				Totale:
			</vs-td>
			<vs-td style="font-weight: bold;">
			{{ totalPercent.toString() }} %
			</vs-td>
			<vs-td style="font-weight: bold;">
				{{ ((totalPercent/100)* $props.mission.price).toFixed(2) }} €
			</vs-td>
			<vs-td>

			</vs-td>
        </vs-tr>
    </template>
    </vs-table>
				<!-- <vs-select
						v-model="missionSelected"
						class="w-full select-large"
						placeholder="Add"
						:key = "productRefreshkey"
						autocomplete
						multiple

					>
						<vs-select-item
							:key="index"
							:value="item.perform"
							:text="item.perform"
							v-for="(item, index) in missionList"
							class="w-full"
						/>
					</vs-select> -->
					<!-- <div v-for="(item,index) in flexibleMissions" :key="index" class="centerx labelx flex">
						<div>
    <vs-input :label="item.mission" placeholder="Budget Percentage" v-model="item.budgetPer"/>
	<div class="pl-10">
		Budget
	{{ (item.budgetPer/100)* $props.mission.price}}
</div> -->
<!-- <div class="pl-10">
	Consultant
	<vs-select
						v-model="item.consultant"
						class="w-full select-large"
						placeholder="Consultant"

					>
						<vs-select-item
							:key="index"
							:value="item1.value"
							:text="item1.name"
							v-for="(item1, index) in allCollabList"
							class="w-full"
						/>
					</vs-select>
				</div>
				</div>
  </div> -->
  <div v-if ="missionSelected.length <= 0">
				<br></br>
				<br></br>
				<br></br>
				<br></br>
			</div>
<div style="
    display: flex;
    justify-content: center;">
				<div v-if = "isLoadingButton">Chargement...</div>
				<vs-button v-else @click="formSubmit()" :class="{ 'opacity-50 cursor-not-allowed': !mission.is_editable }">Valider</vs-button>
			</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";
import CircularLoader from "../widgets/loader/CircularLoader.vue";

export default {
	components: { CircularLoader },
	name: "FlexibleMissionDivisionPopup",
	props: {
		isPopupActive: Boolean,
		mission: Object,
		isEdit: Boolean,
		thisPeriod: String,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			totalPercent: 0,
			missionSelected: null,
			isLoading: false,
			isLoadingButton: false,
			fromEdit: false,
			errorMessage: "",
			subMissionList: [],
			budgetSelected: "",
			isPercentageUse: null,
			missionList: [],
			flexibleMissions: [],
			allCollabList: [],
			productRefreshkey: 0,
			contentListIds: [],
			isPopUpActive: this.$props.isPopupActive,
		};
	},
	async created() {
		await this.getAllProductsForCategory();
		store.dispatch("getAllCollaborators");
		store.dispatch("getContentProduct");
		store.dispatch("getRedacLang");
		let productList = [];
		if (this.$props.isEdit) {
			try {
				this.isLoading = true;
				let res = await this.$http(
					`mission/getFlexibleMissions?mission_id=${this.$props.mission.flex_mission_id}&period=${this.$props.thisPeriod}`
				);
				this.subMissionList = res.data;
				this.subMissionList.forEach((ele) => {
					let product_name = this.missionList.filter(
						(ele1) => ele1.id == ele.products_id
					);
					productList.push(product_name[0].perform);
				});
				this.fromEdit = true;
				this.missionSelected = productList;
				this.productRefreshkey++;
				this.isLoading = false;
			} catch (err) {
				//console.log("Error in FlexibleMissionDivisionPopup.vue: created", err);
			}
		} else {
			this.missionSelected = this.missionList;
		}
	},
	updated() {},
	watch: {
		missionSelected: function (data) {
			//  }
			if (this.fromEdit) {
				data.forEach((ele) => {
					let thisMission = this.subMissionList.filter(
						(mission) => mission.perform == ele
					)[0];
					this.flexibleMissions.push({
						mission: ele,
						budgetPer: thisMission.budgetPer,
						consultant: thisMission.user_id,
						product_id: thisMission.products_id,
						category: thisMission.category,
						language: thisMission.language,
						num_words: thisMission.num_words,
						budgetAmount: thisMission.budgetAmount,
					});

					this.flexibleMissions.forEach((ele, index) => {
						if (!data.includes(ele.mission)) {
							this.flexibleMissions.splice(index, 1);
						}
					});
					this.fromEdit = false;
				});
				let allList = JSON.parse(JSON.stringify(this.missionList));
				allList.forEach((ele, index) => {
					if (data.includes(ele.perform)) {
						allList.splice(index, 1);
					}
				});
				allList.forEach((ele) => {
					let consultant = this.checkPossibleConsultant(
						ele.perform,
						this.$props.mission.flex_user_id
					);
					this.flexibleMissions.push({
						mission: ele.perform,
						budgetPer: null,
						consultant: consultant,
						product_id: ele.id,
						category: "",
						language: 1,
						num_words: "",
					});
				});
				this.calcSum();
			} else {
				data.forEach((ele) => {
					let consultant = this.checkPossibleConsultant(
						ele.perform,
						this.$props.mission.flex_user_id
					);
					this.flexibleMissions.push({
						mission: ele.perform,
						budgetPer: null,
						consultant: consultant,
						product_id: ele.id,
						category: "",
						language: 1,
						num_words: "",
					});
				});
				/*
				 * 	data.forEach((ele) => {
				 *  if(!JSON.stringify(this.flexibleMissions).includes(ele)){
				 * 			let consultant = this.checkPossibleConsultant(ele);
				 * 			let thisProduct= this.missionList.filter((ele1) => ele1.perform == ele);
				 * 			this.flexibleMissions.push({mission: ele, budgetPer: null, consultant: consultant, product_id: thisProduct[0].id});
				 *  }
				 *  this.flexibleMissions.forEach((ele, index) => {
				 * 			if(!data.includes(ele.mission)){
				 * 				this.flexibleMissions.splice(index, 1);
				 * 			}
				 *  });
				 *  //console.log(this.flexibleMissions);
				 * 	});
				 */
			}
		},
		/*
		 * budgetSelected: function(data){
		 * },
		 */
		collaborators: function (data) {
			this.allCollabList = this.sortABC(
				data.filter((collaborator) => [3, 6, 9].includes(collaborator.type)),
				"firstname"
			).map((row) => {
				return { value: row.id, name: row.firstname + " " + row.lastname };
			});
		},
		contentProducts: function (data) {
			let listIds = [];
			data.forEach((ele) => {
				listIds.push(ele.id);
			});
			this.contentListIds = listIds;
		},
		isGreyPercentBackground(newValue) {
			// Access the input element using the ref and update the background color
			for (let i = 0; i < this.$refs.myInput.length; i++) {
				let thisInput = this.$refs.myInput[i];
				const inputElement = thisInput.$el.querySelector(".vs-input--input");
				if (inputElement) {
					inputElement.style.backgroundColor = newValue ? "lightgray" : "";
				}
			}
		},
		isGreyAmountBackground(newValue) {
			// Access the input element using the ref and update the background color
			for (let i = 0; i < this.$refs.myAmountInput.length; i++) {
				let thisInput = this.$refs.myAmountInput[i];
				const inputElement = thisInput.$el.querySelector(".vs-input--input");
				if (inputElement) {
					inputElement.style.backgroundColor = newValue ? "lightgray" : "";
				}
			}
		},
	},
	computed: {
		contentLang: () => {
			return store.state.redac_lang;
		},
		contentProducts: () => {
			return store.state.contentProducts;
		},
		allContractsUsers: () => {
			return store.state.contracts_users;
		},
		collaborators: () => {
			return store.state.collaborators;
		},
		isGreyPercentBackground() {
			// Determine the background color based on your condition
			return this.isPercentageUse == false;
		},
		isGreyAmountBackground() {
			// Determine the background color based on your condition
			return this.isPercentageUse == true;
		},
	},
	methods: {
		handleInputChange(event, id) {
			if (id == 1) {
				this.isPercentageUse = true;
				this.calcSum();
			}
			if (id == 2) {
				this.isPercentageUse = false;
				this.calcSumByNumber();
			}
		},
		calcSum() {
			this.totalPercent = 0;
			let totalBudget = this.$props.mission.price;
			let currentFlexibleMission = this.flexibleMissions.filter(
				(ele) => ele.budgetPer > 0
			);
			currentFlexibleMission.forEach((ele) => {
				if (!ele.budgetPer) {
					this.totalPercent += 0;
					ele.budgetAmount = 0;
				} else {
					ele.budgetAmount = (Number(ele.budgetPer) / 100) * totalBudget;
					this.totalPercent += Number(ele.budgetPer);
				}
			});
		},
		calcSumByNumber() {
			this.totalPercent = 0;
			let totalBudget = this.$props.mission.price;
			let currentFlexibleMission = this.flexibleMissions.filter(
				(ele) => ele.budgetAmount > 0
			);
			currentFlexibleMission.forEach((ele) => {
				if (!ele.budgetAmount) {
					let percent = 0;
					ele.budgetPer = Number(percent);
					this.totalPercent += Number(percent);
				} else {
					let percent = (ele.budgetAmount / totalBudget) * 100;
					ele.budgetPer = Number(percent);
					this.totalPercent += Number(percent);
				}
			});
		},

		checkPossibleConsultant(missionName, defaultConsultant) {
			// Always assign to lead consultant instead of different consultants based on sub_category
			return defaultConsultant;
		},
		getAllProductsForCategory() {
			return new Promise((resolve, reject) => {
				this.$http
					.get("product/all/1")
					.then((res) => {
						this.missionList = res.data.filter((ele) => ele.flexible == 1);
						resolve("Done");
					})
					.catch((err) => {
						reject(err);
						console.error(err);
					});
			});
		},
		async formSubmit() {
			// Check if task is not editable
			if (!this.mission.is_editable) {
				this.$vs.notify({
					title: 'Tâche déjà effectuée',
					text: 'Cette tâche a déjà été effectuée et ne peut plus être modifiée.',
					color: 'warning',
					icon: 'warning'
				});
				return;
			}

			try {
				this.isLoadingButton = true;
				let sum = 0;

				// let budgetSum = this.flexibleMissions.reduce((partialSum, a) => Number(partialSum.budgetPer) + Number(a.budgetPer), 0);
				let currentFlexibleMission = this.flexibleMissions.filter(
					(ele) => ele.budgetPer > 0
				);

				currentFlexibleMission.forEach((ele) => {
					sum += Number(ele.budgetPer);
				});
				if (Math.abs(sum - 100) > 0.01) {
					this.isLoadingButton = false;
					throw Error("Le totale percentage doit être 100");
				} else {
					try {
						let taskBody = {
							commentary: this.$props.mission.commentary,
							flexible: this.$props.mission.flexible,
							status: 1,
							finished_date: this.$props.mission.finished_date,
							recurrence: this.$props.mission.recurrence,
							frequency: this.$props.mission.frequency,
							contract_id: this.$props.mission.contract_id,
							creation_date: this.$props.mission.start_date,
							contract_society_id: this.$props.mission.contract_society_id,
							insertId: this.$props.mission.id,
							price: this.$props.mission.price,
						};
						let flexMisisonBody = [];
						currentFlexibleMission.forEach((flexMiss) => {
							let thisProduct = this.missionList.filter(
								(ele1) => ele1.perform == flexMiss.mission
							);

							flexMisisonBody.push({
								task_body: { ...taskBody, task: flexMiss },
								budgetPer: flexMiss.budgetPer,
								user_id: flexMiss.consultant,
								mission_id: this.$props.mission.id,
								product_id: thisProduct[0].id,
								thisPeriod: this.$props.thisPeriod,
								is_netlink: flexMiss.product_id == 23 ? true : false,
								is_content_mission: this.contentListIds.includes(
									thisProduct[0].id
								),
								category: flexMiss.category || null,
								language: flexMiss.language || 1,
								num_words: flexMiss.num_words || 0,
								budget: (flexMiss.budgetPer / 100) * this.$props.mission.price,
							});
						});
						//console.log(flexMisisonBody);
						await this.$http.post(
							"mission/newSubFlexibleMission",
							flexMisisonBody
						);

						this.$vs.notify({
							title: "Succès",
							text: "Prestaion ajouté avec succès.",
						});
						store.dispatch("getAllFlexibleMissions");

						this.isLoadingButton = false;
						this.isPopUpActive = false;
					} catch (err) {
						//console.log(err);
						this.isLoadingButton = false;
						throw Error(
							"Prestaion n'a pas été ajouté. Peut-être taches est déja fait"
						);
					}
				}
			} catch (err) {
				this.isLoadingButton = false;
				this.$vs.notify({
					title: "Erreur",
					color: "danger",
					text: err.toString(),
				});
			}
		},
	},
};
</script>

<style>
</style>
